import { Typography, styled } from '@mui/material';

export type StyledLineclampTypographyProps = {
  lines?: number;
  showFullText?: boolean;
};

export const LineClampText = styled(Typography, {
  shouldForwardProp: (prop) =>
    !['lines', 'showFullText'].includes(prop as string),
})<StyledLineclampTypographyProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: ${({ showFullText }) => (showFullText ? 'block' : '-webkit-box')};
  -webkit-line-clamp: ${({ lines }) => lines ?? 2};
  -webkit-box-orient: vertical;
  white-space: normal;
  word-break: normal;
`;

export const ToggleText = styled(Typography)({
  textDecoration: 'underline',
  '&:hover': {
    cursor: 'pointer',
  },
});
